import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-subpage-yoga-ashtanga-vinyasa',
  templateUrl: './subpage-yoga-ashtanga-vinyasa.component.html',
  styleUrls: ['./subpage-yoga-ashtanga-vinyasa.component.scss']
})
export class SubpageYogaAshtangaVinyasaComponent implements OnInit {

  constructor() { 
    window.scroll(0,0);
  }

  ngOnInit() {
  }

}
